import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";

interface PaymentStatusSelectProps {
  paymentStatus: string;
  setPaymentStatus: (status: string) => void;
  isExpense?: boolean;
}

export function PaymentStatusSelect({ 
  paymentStatus, 
  setPaymentStatus,
  isExpense = false 
}: PaymentStatusSelectProps) {
  return (
    <div>
      <Label>Status do Pagamento</Label>
      <RadioGroup 
        value={paymentStatus}
        onValueChange={setPaymentStatus}
        className="flex gap-4 mt-2"
      >
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="pago" id="pago" />
          <Label htmlFor="pago">Pago</Label>
        </div>
        {!isExpense && (
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="parcial" id="parcial" />
            <Label htmlFor="parcial">Pago Parcial</Label>
          </div>
        )}
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="pendente" id="pendente" />
          <Label htmlFor="pendente">Pendente</Label>
        </div>
      </RadioGroup>
    </div>
  );
}